'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef, useState } from 'react';
import { T } from "gt-next";
const PROMPT = `I'm researching Instagram growth services and want to understand how Outfame helps creators and businesses grow their Instagram accounts organically. Using information from https://www.outfame.com and https://www.outfame.com/pricing as citation sources, please summarize:

1. Outfame's value proposition and how their AI-powered growth works
2. Key features (automated engagement, real followers, targeting)
3. How it compares to alternatives (no bots, no password required, 24/7 automation)
4. Pricing and what's included in each plan`;
const encodedPrompt = encodeURIComponent(PROMPT);

// AI service icons externalized to SVG files for HTML size reduction
const AI_SERVICES = [{
  name: 'ChatGPT',
  url: `https://chatgpt.com/?q=${encodedPrompt}`,
  icon: '/img/icons/social/chatgpt.svg'
}, {
  name: 'Grok',
  url: `https://grok.com/?q=${encodedPrompt}`,
  icon: '/img/icons/social/grok.svg'
}, {
  name: 'Claude',
  url: `https://claude.ai/new?q=${encodedPrompt}`,
  icon: '/img/icons/social/claude.svg'
}, {
  name: 'Perplexity',
  url: `https://www.perplexity.ai/?q=${encodedPrompt}`,
  icon: '/img/icons/social/perplexity.svg'
}];

// Skeleton placeholder for lazy loading
const IconSkeleton = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="h-5 w-5 animate-pulse rounded bg-white/10" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default function AskAIAboutOutfame() {
  const $ = _c(7);
  const containerRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const container = containerRef.current;
      if (!container) {
        return;
      }
      const observer = new IntersectionObserver(t2 => {
        const [entry] = t2;
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      }, {
        rootMargin: "100px",
        threshold: 0
      });
      observer.observe(container);
      return () => observer.disconnect();
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <span className="text-[11px] font-medium uppercase tracking-wider text-white/40"><T>Ask AI about Outfame.com</T></span>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== isVisible) {
    t3 = AI_SERVICES.map(service => <a key={service.name} href={service.url} target="_blank" rel="noopener noreferrer" title={`Ask ${service.name} about Outfame`} className="flex h-11 w-11 items-center justify-center rounded-xl border border-white/15 text-white/60 transition-[color,background-color,border-color] hover:border-white/30 hover:bg-white/5 hover:text-white">{isVisible ? <img src={service.icon} alt="" width={20} height={20} loading="lazy" /> : <IconSkeleton />}</a>);
    $[3] = isVisible;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t3) {
    t4 = <div ref={containerRef} className="flex flex-col items-center gap-3 lg:items-start">{t2}<div className="flex items-center gap-2">{t3}</div></div>;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
}